const baseFontSize = 0.5;
const ratio = 0.75;

export const fontSizeAsRem = number => `${baseFontSize / ratio ** number}rem`;
